// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"31005da3","419":"be6b7ae6","496":"c8a51c1e","524":"f260ff3e","715":"0854f350","753":"38e6ecd1","774":"b6ea7517","858":"d4ec02ad","883":"44291bc2"}[chunkId] + ".chunk.js";
};